import React from 'react';
import { user_listUsers_data, user_listUsers_data_shipping_addresses, user_listUsers_data_billing_addresses } from '@api/graphql/types';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose } from 'react-apollo';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Mutations from '@api/graphql/mutations';
import { Notification } from 'components';
import { RouterProps, withRouter } from 'react-router';

interface PropType {
    user: user_listUsers_data;
}

type Props = PropType & InjectedIntlProps & RouterProps;

class UserAddresses extends React.Component<Props> {

    private label(id: string): string {
        return this.props.intl.formatMessage({ id: `module.user.${id}` });
    }

    private renderShippingAddress(address: user_listUsers_data_shipping_addresses, index: number) {

        return (
            <div key={`shipping-${index}`} className="row">
                <div className="col-sm-3"><strong>{address.name}</strong></div>
                <div className={`col-sm-9`} style={{ fontWeight: (address.is_default ? 'bold' : 'normal') }}>
                    {address.postcode} {address.city}, {address.street} {address.house_number} {address.telephone}<br />
                    {address.note}
                </div>
            </div>
        );
    }

    private renderShippingAddresses() {
        const addresses = this.props.user.shipping_addresses;
        if (addresses && addresses.length) {
            return (
                <>
                    <h3>{this.label('shipping_addresses.title')}</h3>
                    {addresses.map((address, index) => this.renderShippingAddress(address, index))}
                </>
            );
        }
        return (
            <h3>{this.label('shipping_addresses.no_data')}</h3>
        );
    }

    private toggleTransfer = async (addressId: string, enable: boolean) => {
        try {
            await GraphQLClient.mutate({
                mutation: Mutations.enableBankTransferForBillingAddress,
                variables: {
                    address_id: addressId,
                    enable: !enable,
                },
            });
            await Notification.success(this.props.intl.formatMessage({ id: 'notification.succeed' }));
            this.props.history.goBack();
        } catch (error) {
            Notification.error(this.props.intl.formatMessage({ id: 'notification.failed' }));
        }
    }

    private toggleTransferButton = (address: user_listUsers_data_billing_addresses): JSX.Element => {
        return (
            <button
                className={`btn btn-${address.bank_transfer_enabled ? 'danger' : 'primary'} btn-sm`}
                onClick={() => this.toggleTransfer(address.id, address.bank_transfer_enabled)}
            >
                <i className="fa fa-credit-card" /> {this.label(`${address.bank_transfer_enabled ? 'disable' : 'enable'}_transfer`)}
            </button>
        );
    }

    private renderBillingAddress = (address: user_listUsers_data_billing_addresses, index: number) => {
        return (
            <div key={`billing-${index}`} className="row">
                <div className="col-sm-3"><strong>{address.name}</strong></div>
                <div className={`col-sm-5`} style={{ fontWeight: (address.is_default ? 'bold' : 'normal') }}>
                    {address.postcode} {address.city}, {address.street} {address.house_number}
                </div>
                <div className="col-sm-4">
                    {this.toggleTransferButton(address)}
                </div>
            </div >
        );
    }

    private renderBillingAddresses() {
        const addresses = this.props.user.billing_addresses;
        if (addresses && addresses.length) {
            return (
                <>
                    <h3>{this.label('billing_addresses.title')}</h3>
                    {addresses.map((address, index) => this.renderBillingAddress(address, index))}
                </>
            );
        }
        return (
            <h3>{this.label('billing_addresses.no_data')}</h3>
        );
    }

    public render() {
        return (
            <>
                <div className="row">
                    {this.renderShippingAddresses()}
                </div>
                <hr />
                <div className="row">
                    {this.renderBillingAddresses()}
                </div>
            </>
        );
    }
}

export default compose(
    injectIntl,
    withRouter,
)(UserAddresses);



// WEBPACK FOOTER //
// ./src/modules/User/components/UserAddresses.tsx